import {Wrapper} from "./installPromptModal.style";
import React, {useEffect, useRef, useState} from "react";
import {SwiperSlide, Swiper} from "swiper/react";
import "swiper/css"
import "swiper/css/navigation"
import {motion, useScroll, useTransform, AnimatePresence} from "framer-motion";
import signUpImage from "assets/images/signUpImage.png"
import {Variants} from "motion";
import {DrawerComponent} from "../drawer/drawer.component";
import {IconButtonComponent} from "../button/iconButton.component";

export const InstallPromptModalComponent = () => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isDesktop = !isMobile;
    const isInstalled = window!.matchMedia("(display-mode: standalone)").matches ||
        (window.navigator as any)?.standalone === true;
    const welcomeHome = localStorage.getItem("welcome-home") ? JSON.parse(localStorage.getItem("welcome-home") || "") : false


    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [showModal, setShowModal] = useState(false);
    const [showIOSInstruction, setShowIOSInstruction] = useState(false);
    const [containerEl, setContainerEl] = useState<any>(null);

    useEffect(() => {
        let initialShowModal = false;

        if (isMobile && !isInstalled) initialShowModal = true;
        if (isDesktop && !welcomeHome) initialShowModal = true;

        setShowModal(initialShowModal);
    }, [isMobile, isDesktop, isInstalled, welcomeHome]);
    useEffect(() => {
        const handler = (e: any) => {
            e.preventDefault();
            console.log("beforeinstallprompt fired", e);
            setDeferredPrompt(e);
            setShowModal(true);
        };

        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    useEffect(() => {
        if (isInstalled) return;

        const handler = (e: any) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowModal(true);
        };

        if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
            const lastShown = localStorage.getItem('ios_install_prompt_last_shown');
            const oneWeekAgo = Date.now() - (7 * 24 * 60 * 60 * 1000);

            if (!lastShown || parseInt(lastShown) < oneWeekAgo) {
                setTimeout(() => {
                    setShowModal(true);
                }, 5000);
            }
        }

        window.addEventListener("beforeinstallprompt", handler);

        return () => {
            window.removeEventListener("beforeinstallprompt", handler)
        };
    }, [isInstalled]);


    useEffect(() => {
        if (modalRef.current) {
            setContainerEl(modalRef);
        }
        if (showModal) {
            // document.body.style.overflowY = "hidden";
            // document.body.style.pointerEvents = "none"
        } else {
            // document.body.style.overflowY = "auto";
            // document.body.style.pointerEvents = "auto"
        }
    }, [showModal])

    const modalRef = useRef<HTMLDivElement>(null);
    const {scrollY} = useScroll({
        container: containerEl ?? undefined
    });

    const buttonY = useTransform(scrollY, [0, 90], [-120, 0]);

    // Mobile-specific animations
    const modalVariants: Variants = {
        hidden: {
            y: "100%",
            opacity: 0
        },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                damping: 25,
                stiffness: 300
            }
        },
        exit: {
            y: "100%",
            opacity: 0,
            transition: {
                duration: 0.3,
                ease: "easeInOut"
            }
        }
    };

    const overlayVariants: Variants = {
        hidden: {opacity: 0},
        visible: {opacity: 1},
        exit: {opacity: 0}
    };

    const handleClose = () => {
        if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
            localStorage.setItem('ios_install_prompt_last_shown', Date.now().toString());
        }
        setShowModal(false);
    };

    const handleMaybeLater = () => {
        if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
            localStorage.setItem('ios_install_prompt_last_shown', Date.now().toString());
        }
        setShowModal(false);
    };

    const handleGetStarted = () => {
        localStorage.setItem("welcome-home", "true");
        setShowModal(false);
    };

    const handleInstall = async () => {
        if (!deferredPrompt) {
            return
        }
        try {
            deferredPrompt.prompt();

            const {outcome} = await deferredPrompt.userChoice;

            if (outcome === 'accepted') {
                setShowModal(false);
            } else {
                setShowModal(false);
            }

        } catch (error) {
            setShowModal(false);
        }
    };

    // For desktop users who have already seen the welcome screen
    if (isDesktop && welcomeHome) return null;

    const features = [
        {
            icon: (
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15 12.5V18.75M18.75 2.5L11.25 2.5M15 28.75C8.7868 28.75 3.75 23.7132 3.75 17.5C3.75 11.2868 8.7868 6.25 15 6.25C21.2132 6.25 26.25 11.2868 26.25 17.5C26.25 23.7132 21.2132 28.75 15 28.75Z"
                        stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ),
            title: "Lightning-Fast Payments",
            description: "Pay bills in under 2 minutes with our optimized mobile experience",
            bgColor: "bg-gray-800",
            image: "https://pagedone.io/asset/uploads/1695028873.png"
        },
        {
            icon: (
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M24.6429 11.4286C24.6429 14.3872 20.2457 16.7857 14.8214 16.7857C9.3972 16.7857 5 14.3872 5 11.4286M24.6429 16.7857C24.6429 19.7444 20.2457 22.1429 14.8214 22.1429C9.3972 22.1429 5 19.7444 5 16.7857M24.6429 22.1429C24.6429 25.1015 20.2457 27.5 14.8214 27.5C9.3972 27.5 5 25.1015 5 22.1429M24.6429 6.96429C24.6429 9.42984 20.2457 11.4286 14.8214 11.4286C9.3972 11.4286 5 9.42984 5 6.96429C5 4.49873 9.3972 2.5 14.8214 2.5C20.2457 2.5 24.6429 4.49873 24.6429 6.96429Z"
                        stroke="white" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            ),
            title: "Bank-Grade Security",
            description: "Your financial data is protected with enterprise-level encryption",
            bgColor: "bg-indigo-600"
        },
        {
            icon: (
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M26.7301 15.661C26.7301 22.1995 21.306 27.5 14.6151 27.5C7.9241 27.5 2.5 22.1995 2.5 15.661C2.5 9.1225 7.9241 3.822 14.6151 3.822M18.1313 10.1507L18.1313 4.85383C18.1313 3.22503 19.6455 2.00299 21.1519 2.70013C23.7608 3.90751 26.6177 6.25557 27.456 10.2563C27.7542 11.6798 26.4931 12.8563 25.0064 12.8368L20.7873 12.7814C19.3147 12.762 18.1313 11.5899 18.1313 10.1507Z"
                        stroke="white" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            ),
            title: "Smart Bill Management",
            description: "Auto-reminders and payment history to keep your finances organized",
            bgColor: "bg-violet-600"
        }
    ];
    const ArrowIcon = () => (
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 9L3.58579 6.41421C4.25245 5.74755 4.58579 5.41421 4.58579 5C4.58579 4.58579 4.25245 4.25245 3.58579 3.58579L1 1"
                stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );

    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

    return (
        <Wrapper>
            <AnimatePresence>
                {showModal && (
                    <>
                        <motion.div
                            className="install-modal-overlay"
                            variants={overlayVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                        >
                            <motion.div
                                ref={modalRef}
                                className="install-modal relative rounded-t-3xl md:rounded-3xl max-w-full md:max-w-5xl"
                                variants={modalVariants}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                style={{
                                    overflow: "auto",
                                }}
                            >
                                {!isMobile && <motion.button
                                    className="absolute top-4 right-4 z-20 md:hidden"
                                    onClick={handleClose}
                                    whileTap={{scale: 0.9}}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2"
                                              strokeLinecap="round"/>
                                    </svg>
                                </motion.button>}
                                {/* Header Section */}
                                <motion.div
                                    style={{
                                        background: `url(${signUpImage})`,
                                        backgroundSize: 'cover',
                                    }}
                                    className="welcome-hero flex flex-col items-center justify-center text-center space-y-4 mb-8 px-2 md:px-0"
                                    initial={{opacity: 0, y: 20}}
                                    animate={{opacity: 1, y: 0}}
                                    transition={{delay: 0.1}}
                                >
                                    <div className="mt-8 md:mt-0">
                                        <motion.svg
                                            className="!w-[120px] md:!w-[150px]"
                                            viewBox="0 0 136 46"
                                            fill="none"
                                            initial={{scale: 0.8, opacity: 0}}
                                            animate={{scale: 1, opacity: 1}}
                                            transition={{delay: 0.2, type: "spring"}}
                                        >
                                            <path
                                                d="M20.53 14.6H8V17.43H20.53V19.77H8V21.97V22.6V28.57V29.98V31.4H13.19H16.02V28.57L18.87 31.39V31.4H23.36V28.57H20.04L16.02 24.58V24.56H13.19V28.57H10.83V22.6H20.53H23.36V19.77V17.43V14.6H20.53Z"
                                                fill="#3900BD"/>
                                            <path
                                                d="M34.8132 31V14.2727H41.4126C42.6759 14.2727 43.754 14.4987 44.647 14.9506C45.5455 15.3971 46.2288 16.0315 46.6971 16.8537C47.1708 17.6705 47.4077 18.6315 47.4077 19.7369C47.4077 20.8477 47.1681 21.8033 46.6889 22.6037C46.2098 23.3987 45.5155 24.0085 44.6062 24.4332C43.7023 24.858 42.6078 25.0703 41.3228 25.0703H36.9041V22.228H40.7511C41.4263 22.228 41.9871 22.1354 42.4336 21.9503C42.8801 21.7652 43.2122 21.4875 43.43 21.1172C43.6533 20.7469 43.7649 20.2868 43.7649 19.7369C43.7649 19.1815 43.6533 18.7132 43.43 18.332C43.2122 17.9509 42.8774 17.6623 42.4254 17.4663C41.9789 17.2648 41.4154 17.1641 40.7347 17.1641H38.3498V31H34.8132ZM43.8466 23.3878L48.0039 31H44.0998L40.0323 23.3878H43.8466ZM53.321 23.7472V31H49.8416V14.2727H53.223V20.668H53.37C53.6532 19.9274 54.1106 19.3475 54.7422 18.9283C55.3738 18.5036 56.1661 18.2912 57.119 18.2912C57.9902 18.2912 58.7498 18.4818 59.3977 18.8629C60.0511 19.2386 60.5575 19.7804 60.9169 20.4883C61.2817 21.1907 61.4614 22.032 61.456 23.0121V31H57.9766V23.6328C57.982 22.8596 57.786 22.2579 57.3885 21.8278C56.9964 21.3976 56.4465 21.1825 55.7386 21.1825C55.2649 21.1825 54.8456 21.2833 54.4808 21.4847C54.1214 21.6862 53.8383 21.9802 53.6314 22.3668C53.4299 22.748 53.3265 23.2081 53.321 23.7472ZM69.8625 31.245C68.5938 31.245 67.4966 30.9755 66.5709 30.4364C65.6507 29.8919 64.9401 29.1351 64.4392 28.1658C63.9382 27.1912 63.6878 26.0613 63.6878 24.7763C63.6878 23.4804 63.9382 22.3478 64.4392 21.3786C64.9401 20.4039 65.6507 19.647 66.5709 19.108C67.4966 18.5634 68.5938 18.2912 69.8625 18.2912C71.1312 18.2912 72.2256 18.5634 73.1459 19.108C74.0715 19.647 74.7848 20.4039 75.2858 21.3786C75.7867 22.3478 76.0372 23.4804 76.0372 24.7763C76.0372 26.0613 75.7867 27.1912 75.2858 28.1658C74.7848 29.1351 74.0715 29.8919 73.1459 30.4364C72.2256 30.9755 71.1312 31.245 69.8625 31.245ZM69.8788 28.5497C70.456 28.5497 70.9379 28.3864 71.3245 28.0597C71.7111 27.7275 72.0024 27.2756 72.1984 26.7038C72.3999 26.1321 72.5006 25.4814 72.5006 24.7518C72.5006 24.0221 72.3999 23.3714 72.1984 22.7997C72.0024 22.228 71.7111 21.776 71.3245 21.4439C70.9379 21.1117 70.456 20.9457 69.8788 20.9457C69.2962 20.9457 68.8061 21.1117 68.4086 21.4439C68.0166 21.776 67.7198 22.228 67.5184 22.7997C67.3224 23.3714 67.2243 24.0221 67.2243 24.7518C67.2243 25.4814 67.3224 26.1321 67.5184 26.7038C67.7198 27.2756 68.0166 27.7275 68.4086 28.0597C68.8061 28.3864 69.2962 28.5497 69.8788 28.5497ZM78.2996 31V18.4545H81.6157V20.668H81.7627C82.0241 19.9329 82.4597 19.353 83.0695 18.9283C83.6794 18.5036 84.409 18.2912 85.2584 18.2912C86.1188 18.2912 86.8511 18.5063 87.4555 18.9364C88.0599 19.3611 88.4629 19.9383 88.6643 20.668H88.795C89.0509 19.9492 89.5138 19.3748 90.1835 18.9446C90.8587 18.509 91.6564 18.2912 92.5766 18.2912C93.7473 18.2912 94.6975 18.6642 95.4271 19.4102C96.1622 20.1507 96.5297 21.2016 96.5297 22.5629V31H93.0585V23.2489C93.0585 22.552 92.8734 22.0292 92.5031 21.6808C92.1328 21.3323 91.67 21.158 91.1146 21.158C90.483 21.158 89.9902 21.3595 89.6363 21.7624C89.2823 22.1599 89.1054 22.6854 89.1054 23.3388V31H85.7322V23.1754C85.7322 22.5601 85.5552 22.0701 85.2013 21.7053C84.8528 21.3404 84.3927 21.158 83.8209 21.158C83.4343 21.158 83.0858 21.256 82.7755 21.4521C82.4706 21.6426 82.2282 21.9122 82.0486 22.2607C81.8689 22.6037 81.779 23.0066 81.779 23.4695V31H78.2996ZM99.3435 31V14.2727H102.823V20.5618H102.929C103.082 20.2242 103.302 19.8812 103.591 19.5327C103.885 19.1787 104.266 18.8847 104.734 18.6506C105.208 18.411 105.796 18.2912 106.498 18.2912C107.413 18.2912 108.257 18.5308 109.03 19.0099C109.803 19.4837 110.421 20.1997 110.884 21.158C111.347 22.1109 111.579 23.3061 111.579 24.7436C111.579 26.143 111.353 27.3246 110.901 28.2884C110.454 29.2467 109.844 29.9736 109.071 30.4691C108.303 30.9592 107.443 31.2042 106.49 31.2042C105.815 31.2042 105.241 31.0926 104.767 30.8693C104.299 30.6461 103.915 30.3656 103.615 30.0281C103.316 29.685 103.087 29.3393 102.929 28.9908H102.774V31H99.3435ZM102.749 24.7273C102.749 25.4732 102.853 26.1239 103.06 26.6793C103.267 27.2347 103.566 27.6676 103.958 27.978C104.35 28.2829 104.827 28.4354 105.388 28.4354C105.954 28.4354 106.433 28.2802 106.825 27.9698C107.217 27.654 107.514 27.2184 107.715 26.663C107.922 26.1022 108.026 25.4569 108.026 24.7273C108.026 24.0031 107.925 23.366 107.723 22.8161C107.522 22.2661 107.225 21.8359 106.833 21.5256C106.441 21.2152 105.959 21.06 105.388 21.06C104.821 21.06 104.342 21.2098 103.95 21.5092C103.563 21.8087 103.267 22.2334 103.06 22.7834C102.853 23.3333 102.749 23.9813 102.749 24.7273ZM121.945 25.6584V18.4545H125.425V31H122.084V28.7212H121.953C121.67 29.4563 121.199 30.0471 120.540 30.4936C119.887 30.9401 119.089 31.1634 118.147 31.1634C117.309 31.1634 116.571 30.9728 115.934 30.5916C115.297 30.2105 114.799 29.6687 114.439 28.9663C114.085 28.2638 113.906 27.4226 113.9 26.4425V18.4545H117.38V25.8217C117.385 26.5623 117.584 27.1476 117.976 27.5778C118.368 28.0079 118.893 28.223 119.552 28.223C119.971 28.223 120.364 28.1277 120.728 27.9371C121.093 27.7411 121.387 27.4525 121.61 27.0714C121.839 26.6902 121.951 26.2192 121.945 25.6584Z"
                                                fill="white"/>
                                        </motion.svg>
                                    </div>
                                    <motion.div
                                        className="install-modal-header max-w-2xl px-4 md:px-0"
                                        initial={{opacity: 0, y: 10}}
                                        animate={{opacity: 1, y: 0}}
                                        transition={{delay: 0.3}}
                                    >
                                        <h2 className="text-lg md:text-4xl lg:text-5xl  !leading-normal mb-3 md:mb-4">
                                            {isDesktop ? "Welcome to Rhombu" : (isIOS ? "Add to Home Screen" : "Install Our App")}
                                            <span
                                                className="block text-sm text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400 font-medium">
                                            {isDesktop ? "Your Financial Companion" : (isIOS ? "For Better Experience" : "Simple & Secure")}
                                        </span>
                                        </h2>
                                        <p className="text-base font-light md:text-lg text-gray-300 max-w-xl mx-auto">
                                            {isDesktop
                                                ? "Experience seamless bill payments and financial management"
                                                : (isIOS
                                                    ? "Get the app-like experience with faster loading and offline access"
                                                    : "Add funds easily and securely — you're just a few taps away!")}
                                        </p>
                                    </motion.div>
                                </motion.div>

                                {/* Features Slider */}
                                <motion.section
                                    className="features py-6 md:py-8"
                                    initial={{opacity: 0}}
                                    animate={{opacity: 1}}
                                    transition={{delay: 0.4}}
                                >
                                    <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                                        <div className="text-center mb-8 md:mb-12">
                                            <h2 className="text-lg md:text-3xl  font-medium text-white leading-tight mb-2 md:mb-4">
                                                Why Rhombu?
                                            </h2>
                                            <p className="text-sm md:text-base font-normal text-gray-300 opacity-55 max-w-2xl mx-auto px-4 md:px-0">
                                                Get the full power of our bill payment platform with enhanced features
                                                and
                                                performance
                                            </p>
                                        </div>
                                        <Swiper
                                            spaceBetween={16}
                                            slidesPerView={1.1}
                                            breakpoints={{
                                                640: {
                                                    slidesPerView: 1.2,
                                                    spaceBetween: 20
                                                },
                                                768: {
                                                    slidesPerView: 1.8,
                                                    spaceBetween: 20
                                                },
                                                1024: {
                                                    slidesPerView: 2.3,
                                                    spaceBetween: 24
                                                },
                                                1280: {
                                                    slidesPerView: 2.5,
                                                    spaceBetween: 24
                                                }
                                            }}
                                            className="pb-6 md:pb-8 px-2 md:px-0 md:h-[262px] h-[250px]"
                                        >
                                            {features.map((feature, index) => (
                                                <SwiperSlide key={index}>
                                                    <motion.div
                                                        className={`rounded-xl md:rounded-2xl flex flex-col h-full ${feature.bgColor}`}
                                                        whileHover={{scale: 1.02}}
                                                        whileTap={{scale: 0.98}}
                                                    >
                                                        <div className="p-4 md:p-6 xl:p-8 flex-1">
                                                            <div className="mb-3 md:mb-4">
                                                                {feature.icon}
                                                            </div>
                                                            <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4">
                                                                {feature.title}
                                                            </h3>
                                                            <p className="text-xs md:text-sm font-normal
                                                             text-gray-200 mb-4 md:mb-6 leading-relaxed">
                                                                {feature.description}
                                                            </p>
                                                            <motion.button
                                                                className="py-2 px-4 md:px-5 border border-gray-300 rounded-full gap-2 text-xs text-white font-semibold flex items-center justify-between transition-all duration-300 hover:bg-white/10 w-fit"
                                                                whileHover={{scale: 1.05}}
                                                                whileTap={{scale: 0.95}}
                                                            >
                                                                Learn More
                                                                <ArrowIcon/>
                                                            </motion.button>
                                                        </div>
                                                        {feature.image && (
                                                            <div className="hidden md:block relative h-32 lg:h-40">
                                                                <img
                                                                    src={feature.image}
                                                                    alt={feature.title}
                                                                    className="w-full h-full object-cover rounded-b-2xl"
                                                                />
                                                            </div>
                                                        )}
                                                    </motion.div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                                </motion.section>

                                {/* iOS Instructions - Only show for iOS browsers */}
                                <DrawerComponent
                                    open={isIOS && !isInstalled && showIOSInstruction}
                                    headerClassName={"block *:block *:!text-start [&_.header]:w-full"}
                                    header={
                                        <div className="basis-full d-flex align-items-center justify-content-between">
                                            <span className={"text-white"}>iOS Installation</span>
                                            <IconButtonComponent
                                                className={"close-btn !bg-[#1e1e1e]"}
                                                variant={"outline"}
                                                onClick={() => setShowIOSInstruction(false)}
                                            >
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1.87571 0.696715C1.55028 0.371278 1.02264 0.371277 0.697203 0.696715C0.371766 1.02215 0.371766 1.54979 0.697203 1.87523L4.82199 6.00002L0.697203 10.1248C0.371766 10.4502 0.371766 10.9779 0.697203 11.3033C1.02264 11.6288 1.55028 11.6288 1.87571 11.3033L6.0005 7.17853L10.1253 11.3033C10.4507 11.6288 10.9784 11.6288 11.3038 11.3033C11.6292 10.9779 11.6292 10.4502 11.3038 10.1248L7.17902 6.00002L11.3038 1.87523C11.6292 1.54979 11.6292 1.02215 11.3038 0.696715C10.9784 0.371278 10.4507 0.371278 10.1253 0.696715L6.0005 4.8215L1.87571 0.696715Z"
                                                        fill="currentColor"/>
                                                </svg>
                                            </IconButtonComponent>
                                        </div>
                                    }
                                    $side="bottom"
                                    $size="xl"
                                    // showCloseButton
                                    closeOnOutside
                                    className={"dark"}
                                    $backgroundColor="#1e1e1e"
                                    onOpenChange={() => setShowIOSInstruction(prev => !prev)}
                                    $backdrop
                                >
                                    <div className="space-y-6 *:text-white">
                                        {/* Header */}
                                        <div className="text-center space-y-1">
                                            <h2 className="text-2xl font-semibold">Add to Home Screen</h2>
                                            <p className="text-gray-300 text-sm">Get an app-like experience with one tap access</p>
                                        </div>

                                        {/* Steps */}
                                        <div className="space-y-3">
                                            {[
                                                {
                                                    step: 1,
                                                    title: "Tap Share Button",
                                                    desc: "Tap the ",
                                                    highlight: "share icon",
                                                    descSuffix: " 📤 at the bottom of your browser"
                                                },
                                                {
                                                    step: 2,
                                                    title: 'Find "Add to Home Screen"',
                                                    desc: "Scroll down and select ",
                                                    highlight: '"Add to Home Screen"',
                                                    descSuffix: " from the menu"
                                                },
                                                {
                                                    step: 3,
                                                    title: "Confirm Installation",
                                                    desc: 'Tap ',
                                                    highlight: '"Add"',
                                                    descSuffix: " in the top right corner to complete"
                                                }
                                            ].map(({ step, title, desc, highlight, descSuffix }) => (
                                                <div
                                                    key={step}
                                                    className="flex items-start space-x-3 p-3 rounded-xl border border-gray-700 hover:border-gray-500 transition"
                                                >
                                                    <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                        <span className="text-white font-medium">{step}</span>
                                                    </div>
                                                    <div>
                                                        <p className="font-medium text-white mb-0.5">{title}</p>
                                                        <p className="text-gray-300 text-sm">
                                                            {desc}
                                                            <span className="text-blue-400 font-medium">{highlight}</span>
                                                            {descSuffix}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Tip */}
                                        <div className="mt-4 p-3 bg-gray-800 border border-gray-700 rounded-xl text-center">
                                            <p className="text-yellow-400 text-sm">
                                                💡 <strong>Tip:</strong> This will add Rhombu to your home screen for quick access
                                            </p>
                                        </div>
                                    </div>
                                </DrawerComponent>



                                {/* Install CTA */}
                                <div className="install-buttons">
                                    <motion.div
                                        style={{y: buttonY}}
                                        className="mb-3 md:mb-4">
                                        <motion.button
                                            onClick={isIOS ? () => setShowIOSInstruction(true) : (isDesktop ? handleGetStarted : handleInstall)}
                                            type="button"
                                            className="text-white bg-gradient-to-r from-[#351790] via-[#2b0088]
                                             to-[#4908ee] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300
                                              text-sm md:text-base font-medium cursor-pointer shadow-lg shadow-blue-500/50 rounded-3xl px-6
                                               md:px-10 py-3 md:py-3.5 text-center leading-5 transition-all duration-300 hover:scale-105
                                                w-full max-w-xs md:max-w-none d-flex align-items-center gap-x-2 "
                                            whileHover={{scale: 1.02}}
                                            whileTap={{scale: 0.98}}
                                        >
                                            {isDesktop
                                                ? "🚀 Get Started"
                                                : <>
                                                    {/*{(!isInstalled && !isIOS && !deferredPrompt) && (*/}
                                                    {/*    <Spinner color={"inherit"} size={"sm"}/>*/}
                                                    {/*)}*/}
                                                    <span style={{
                                                        fontSize: "inherit",
                                                        fontWeight: "inherit",
                                                        color: "inherit"
                                                    }}>{isInstalled ? "App already installed" : "📲 Install App for Free"}</span>
                                                </>}
                                        </motion.button>
                                    </motion.div>

                                    {/*{!isDesktop && (*/}
                                    {/*    <motion.button*/}
                                    {/*        onClick={handleMaybeLater}*/}
                                    {/*        className="text-gray-300 hover:text-white text-xs md:text-sm mb-2 transition-colors duration-200"*/}
                                    {/*        whileHover={{scale: 1.05}}*/}
                                    {/*        whileTap={{scale: 0.95}}*/}
                                    {/*    >*/}
                                    {/*        Maybe Later*/}
                                    {/*    </motion.button>*/}
                                    {/*)}*/}

                                    <p className="text-xs text-gray-300 mb-2 text-center px-2 md:px-0">
                                        By {isDesktop ? "proceeding" : "installing"}, you agree to our{" "}
                                        <a
                                            href="/privacy-policy"
                                            target="_blank"
                                            className="underline hover:no-underline"
                                        >
                                            Privacy Policy
                                        </a>{" "}
                                        &{" "}
                                        <a
                                            href="/terms-and-conditions"
                                            target="_blank"
                                            className="underline hover:no-underline"
                                        >
                                            Terms of Service
                                        </a>
                                    </p>

                                    <p className="text-xs text-gray-400 text-center">
                                        🚀 The most reliable bill payment app in Nigeria
                                    </p>
                                </div>
                            </motion.div>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </Wrapper>
    );
};